module.exports = {
  __init__: [ 'bpmnOrderingProvider' ],
  __depends__: [
    require(248)
  ],
  bpmnOrderingProvider: [ 'type', require(69) ]
};